export default "__VITE_ASSET__BEKqXmpZ__"